// @flow
import React, { Component } from 'react';
import styled from 'styled-components';

import BorderedIcon from "../../../components/BorderedIcon";
import ArrowRightIcon from '../../../components/Icons/ArrowRight';
import SettingsIcon from '../../../components/Icons/Settings';
import InviteIcon from '../../../components/Icons/Invite';
import CountdownTimer from '../../../components/CountdownTimer';

import colors from '../../../assets/css/colors';
import { CountdownTimerWrapper, CountdownLabel } from './countdownTimerStyles';
import IconLinkStyled, { IconLinkGroup } from './IconLinkStyled';

import LeagueBase from './LeagueBase';
import getLinkStates from './getLinkStates';
import LeagueStatusLabel from './LeagueStatusLabel';

const LeagueStatusLabelStyled = styled(LeagueStatusLabel)`
	text-align: center;
	margin-right: 40px;
`;

type Props = {
	league: Object,
	onTimerComplete: Function,
	is_commissioner: boolean,
	server_time_diff: number,
};

type State = {
	timer_complete: boolean
}

class FutureLeague extends Component<Props, State> {
	state = {
		timer_complete: false
	};

	onTimerComplete = (date_string: string) => {
		const { onTimerComplete } = this.props;

		onTimerComplete(date_string);

		this.setState({ timer_complete: true });
	};

	renderRightSide = () => {
		const
			{ league, is_commissioner, server_time_diff } = this.props,
			{ timer_complete } = this.state,
			links = getLinkStates(league, is_commissioner),
			initial_shift = 5 * 1000,
			draft_start_milliseconds = (new Date(league.draft_start)).valueOf(),
			draft_start_date = (new Date(
				draft_start_milliseconds + initial_shift + server_time_diff
			)).toString();

		return (
			<React.Fragment>
				{!timer_complete && (
					<CountdownTimerWrapper>
						<CountdownLabel>
							Draft starts in
						</CountdownLabel>
						<CountdownTimer
							key={draft_start_date}
							is_uppercase
							onComplete={this.onTimerComplete.bind(this, draft_start_date)}
							date={draft_start_date}
						/>
					</CountdownTimerWrapper>
				)}

				{timer_complete && (
					<LeagueStatusLabelStyled>
						Draft will start soon. Please wait.
					</LeagueStatusLabelStyled>
				)}

				<IconLinkGroup>
					{Boolean(links.invite) ? (
						<IconLinkStyled to={links.invite} title="Invite">
							<BorderedIcon hover={colors.lightGreen}>
								<InviteIcon
									cursor="pointer"
									size="1.875"
									color={colors.nrlDarkGreen}
								/>
							</BorderedIcon>
						</IconLinkStyled>
					) : null}

					<IconLinkStyled to={links.settings} title="Settings">
						<BorderedIcon hover={colors.lightGreen}>
							<SettingsIcon
								cursor="pointer"
								size="1.875"
								color={colors.nrlDarkGreen}
							/>
						</BorderedIcon>
					</IconLinkStyled>

					<IconLinkStyled to={links.arrow} title="Go to League">
						<BorderedIcon hover={colors.lightGreen}>
							<ArrowRightIcon
								cursor="pointer"
								size="1.875"
								color={colors.nrlDarkGreen}
							/>
						</BorderedIcon>
					</IconLinkStyled>
				</IconLinkGroup>
			</React.Fragment>
		);
	};

	render() {
		const { league, is_commissioner } = this.props;

		return (
			<LeagueBase
				league={league}
				is_commissioner={is_commissioner}
				show_teams_count
				renderRightSide={this.renderRightSide}
			/>
		);
	}
}

export default FutureLeague;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/FutureLeague.js